document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('.js-carousel-main.flickity-enabled') || document.querySelector('.js-carousel-main');
  if (!gallery || typeof Flickity === 'undefined' || typeof variantImages === 'undefined') return;
  var flkty = Flickity.data(gallery);
  if (!flkty) return;

  function stemFromPath(p) {
    var base = (p || '').split('?')[0];
    if (base.indexOf('/files/') > -1) {
      base = base.split('/files/')[1];
    } else if (base.indexOf('/products/') > -1) {
      base = base.split('/products/')[1];
    } else {
      base = base.replace(/^files\//i, '').replace(/^products\//i, '');
    }
    var dot = base.lastIndexOf('.');
    var name = dot > -1 ? base.slice(0, dot) : base;
    var ext = dot > -1 ? base.slice(dot + 1) : '';
    name = name.replace(/_[0-9]+x[0-9]*$/i, '');
    return (name + (ext ? '.' + ext : '')).toLowerCase();
  }

  var keyByStem = {};
  Object.keys(variantImages).forEach(function (k) {
    keyByStem[stemFromPath(k)] = k;
  });

  function selectVariantFromCell(cell) {
    var holder = cell && cell.querySelector('.product-media-container[data-src]');
    if (!holder) return;
    var src = holder.getAttribute('data-src') || '';
    var key = keyByStem[stemFromPath(src)];
    var map = key ? variantImages[key] : null;
    if (!map) return;

    var pop = document.querySelector('.Popover__Value[data-value="' + (map['option-0'] || '').trim() + '"]');
    if (pop) {
      pop.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      return;
    }

    var selects = document.querySelectorAll('.js-variant-selector');
    productOptions.forEach(function (_, i) {
      var val = map['option-' + i];
      var select = selects[i];
      if (!select || val === null) return;
      var opt = Array.prototype.find.call(select.options, function (o) {
        return o.text.trim() === val.trim() || o.value.trim() === val.trim();
      });
      if (opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function onChange() {
    var cell = flkty.selectedElement || gallery.querySelector('.carousel-cell.is-selected');
    selectVariantFromCell(cell);
  }

  flkty.on('change', onChange);
  onChange();
});
